import buriedPoint from './buried-point-service';
import dateService from './format-date-service';

const service = {
  buriedPoint,
  dateService,
};
// 注册service插件
service.install = function (Vue) {
  Vue.prototype.$service = service;
};

export default service;



// WEBPACK FOOTER //
// ./src/services/index.js